module.exports = {
	extends: [
		'/',
		'templates',
		'routeTrees',
		'routeTrees'
	],

	config: {
		style: 'splitScreen',
		mode: 'chooser',
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeTrees',
				'chooseRouteTree'
			]
		},
		nodeActionMapping: {
			defaultBaseActions: {
				select: {
					lang: 'edit_routeContent',
					home: 'edit_routeContent',
					page: 'edit_routeContent'
				},
				deselect: {
					lang: 'edit_routeContent',
					home: 'edit_routeContent',
					page: 'edit_routeContent'
				}
			}
		}
	},

	model: {
		waitForExternalFilters: false,
	},

	methods: {
		dataDealer: function(){
			this.model.highlightRouteIDs = this.getResourceRegisterContent('highlightRouteIDs') || {};
		},

		/**
		 * this function will be called by the trees-component after the attach hook has been done.
		 * NOTE: this gives us the ability to react on the attach hook without overwriting it.
		 */
		onAttachDone: function(){
			// prevent subActions
		}
	},

	// NOTE: prevent routeTrees handlers from being called for this selectRouteTrees-Component
	handlers: undefined
};
